import script from "./Icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./Icon.vue?vue&type=script&lang=ts&setup=true"

import "./Icon.vue?vue&type=style&index=0&id=07aefd46&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07aefd46"]])

export default __exports__